import formatNumber from './format-number';
import { getHasUserSelectedKilogramUnit, getHasUserSelectedMeterUnit } from './get-user-units-pref';
import { UnitsConverter } from './units-converter';

// ref: https://www.spikevm.com/calculators/farming/rd-grain-bins-us-bushels.php

export const calculateBushels = (diameter: number, height: number, inMeters: boolean): number => {
  let diameterVal = diameter;
  let heightVal = height;
  const heightSubtract = 1 / 12; // removing 1inch from height of bin
  const bushelConversionFactor = 0.80356; // cubic feet to bushels conversion factor
  if (inMeters) {
    diameterVal = UnitsConverter.convertMetersToFeet(diameter);
    heightVal = UnitsConverter.convertMetersToFeet(height);
  }

  const cylindricalVol = Math.PI * Math.pow(diameterVal / 2, 2) * (heightVal - heightSubtract);
  const theta = 28;
  const coneHeight = Math.tan((theta * Math.PI) / 180) * (diameterVal / 2);
  const conicalVol = Math.PI * Math.pow(diameterVal / 2, 2) * (coneHeight / 3);
  const nominalPackFactor = 1.06;
  return (cylindricalVol + conicalVol) * bushelConversionFactor * nominalPackFactor;
};

export const estimateAndFormatBushels = (
  diameter: number,
  height: number,
  separator?: string
): string => {
  const in_meters = getHasUserSelectedMeterUnit();
  const bu = calculateBushels(diameter, height, in_meters);
  const hasUserSelectedKgUnit = getHasUserSelectedKilogramUnit();
  const separatorSymbol = separator ? (separator === 'space' ? ' ' : '-') : '-';
  if (hasUserSelectedKgUnit) {
    const tons = UnitsConverter.convertBuToMetricTon(bu);
    return `${formatNumber(tons)}${separatorSymbol}ton`;
  }
  return `${formatNumber(Math.round(bu / 1000) * 1000)}${separatorSymbol}bu`;
};
